import { useAuth } from "../contexts/AuthContext";

const GROCERY_TERMS = {
  product: "Product", products: "Products", sku: "SKU",
  category: "Category", categories: "Categories",
  subcategory: "Subcategory", subcategories: "Subcategories",
  shelf: "Shelf Facings", store: "Store", stores: "Stores",
  assortment: "Assortment", unit: "Unit",
};

/** Returns the active industry vertical's terminology + meta, with a grocery fallback. */
export function useVertical() {
  const { user } = useAuth();
  const cfg = (user && user.vertical_config) || null;
  return {
    id: (user && user.vertical) || "grocery",
    name: cfg?.name || "Grocery",
    tagline: cfg?.tagline || "",
    futures: !!cfg?.futures,
    terms: { ...GROCERY_TERMS, ...(cfg?.terms || {}) },
  };
}

/** Convenience: just the terms map. Usage: const t = useTerms(); t.category */
export function useTerms() {
  return useVertical().terms;
}
